import Vue from 'vue';
import Vuex from 'vuex';

window.axios = require('axios');

if (!window.axios.defaults.headers.common['X-CSRF-Token']) {
    window.axios.get('/session/token').then(response => {
        window.axios.defaults.headers.common['X-CSRF-Token'] = response.data;
    });
}

window.lodash = require('lodash');
import moment from "moment";
import router from './router.js';
import {comment} from "postcss";
import {isNumber} from "lodash";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        activeLocation: {},
        activeLocationOpeningHours: {},
        activePickupPoint: {},
        activeDiscount: null,
        activeDiscountType: 'percentual',
        activeDiscountCode: '',
        departureDate: null,
        departureTime: '08:00',
        returnDate: null,
        returnTime: '08:00',
        timeRange: ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00',],
        vehicleRates: [],
        loadingVehicleRates: false,
        showDiscount: false,
        days: 1,
        kilometers: 100,
        activeVehicle: {},
        currentStep: null,
        rentalOptions: [],
        activeRentalOptions: [],
        upgrade: null,
        upgrades: [],
        downgrade: null,
        isLoggedIn: typeof drupalSettings !== 'undefined' && (drupalSettings.user?.uid ?? 0) > 0,
        form: {
            title: '',
            first_name: '',
            last_name: '',
            street: '',
            house_number: '',
            postal_code: '',
            city: '',
            country: 'NL',
            email: '',
            phone_number: '',
            newsletter: false,
            create_account: false,
            password: '',
            password_confirm: '',
        },
        disabledReservationDates: [],
        loadingRentalRequest: false,
        stepTwoDisabled: false,
        showLocationDropdown: true,
        popUpSettings: {},
        externalRentalOptionPrices: {},
        externalPricesLoading: false,
        beginCheckoutStarted: false,
        activeVehicleWrapper: {},
    },

    getters: {
        getShowDiscount: state => state.showDiscount,
        getActiveLocation: state => state.activeLocation,
        getActiveLocationOpeningHours: state => state.activeLocationOpeningHours,
        getActivePickupPoint: state => state.activePickupPoint,
        getDepartureDate: state => state.departureDate,
        getDepartureTime: state => state.departureTime,
        getReturnDate: state => state.returnDate,
        getReturnTime: state => state.returnTime,
        getBeginCheckoutStarted: state => state.beginCheckoutStarted,
        hasActiveLocation: state => !lodash.isEmpty(state.activeLocation),
        hasActiveLocationOpeningHours: state => {
            return !lodash.isEmpty(state.activeLocationOpeningHours.openinghours) &&
                !lodash.isNil(state.activeLocationOpeningHours.openinghours.starthours);
        },
        hasActivePickupPoint: state => !lodash.isEmpty(state.activePickupPoint),
        getStartDate: state => {
            return `${moment(state.departureDate).format('YYYY-M-D')} ${state.departureTime}`
        },

        getEndDate: state => {
            return `${moment(state.returnDate).format('YYYY-M-D')} ${state.returnTime}`
        },
        getTimeRange: state => state.timeRange,
        getVehicleRates: state => state.vehicleRates,
        getLoadingVehicleRates: state => state.loadingVehicleRates,
        getDays: state => state.days,
        getKilometers: state => {
            return lodash.isEmpty(state.activeVehicle.free_kilometers) ? 100 : state.activeVehicle.free_kilometers
        },
        getActiveVehicle: state => state.activeVehicle,
        getCurrentStep: state => state.currentStep,
        getRentalOptions: state => {
            return lodash.orderBy(state.rentalOptions, 'weight')
        },
        hasRentalOptions: state => !lodash.isEmpty(state.rentalOptions),
        getVehicleUpgrade: state => state.upgrade,
        getVehicleUpgrades: state => state.upgrades,
        getVehicleDowngrade: state => state.downgrade,
        getPopUpSettings: state => state.popUpSettings,
        getExternalRentalOptionPrices: state => state.externalRentalOptionPrices,
        getExternalPricesLoading: state => state.externalPricesLoading,
        getActiveVehicleWrapper: state => state.activeVehicleWrapper,

        getActiveDiscount: state => state.activeDiscount,
        getActiveDiscountType: state => state.activeDiscountType,
        getActiveDiscountCode: state => state.activeDiscountCode,
        hasDiscount: state => isNumber(state.activeDiscount),

        getActiveRentalOptions: state => {
            return lodash.orderBy(lodash.intersectionWith(state.rentalOptions, state.activeRentalOptions, (option, tid) => lodash.isEqual(option.tid, tid)), 'weight');
        },

        getActiveRentalOptionIds: state => {
            const availableRentalOptionIds = state.rentalOptions.map(option => option.tid);
            return state.activeRentalOptions.filter(optionId => availableRentalOptionIds.includes(optionId))
        },

        getIsSundaysOpen: state => {
            if (lodash.isNil(state.activeLocation.sundays)) {
                return false;
            }

            return state.activeLocation.sundays;
        },

        getForm: state => state.form,
        getDisabledReservationDates: state => state.disabledReservationDates,
        getLoadingRentalRequest: state => state.loadingRentalRequest,
        getStepTwoDisabled: state => state.stepTwoDisabled,
        getShowLocationDropdown: state => state.showLocationDropdown,

        getTotalVehicleRates(state, getters) {
          let vehicleRate = 0;
          lodash.forEach(state.vehicleRates, (rate) => {
            vehicleRate = vehicleRate + rate.totalPrice;
          })
          return vehicleRate
        },

        getOptionsTotalRentalPrice: (state, getters) => {
            let rentalPrice = 0;

            if (!lodash.isEmpty(getters.getActiveRentalOptions)) {
                lodash.forEach(getters.getActiveRentalOptions, (option) => {
                    if (getters.getExternalRentalOptionPrices[option.id]) {
                        rentalPrice = rentalPrice + getters.getExternalRentalOptionPrices[option.id].total_price
                        return;
                    }

                    if (option.isOneOff) {
                        rentalPrice = rentalPrice + option.price;
                        return;
                    }

                    rentalPrice = rentalPrice + option.totalPrice;
                });
            }

            return rentalPrice
        },

        getTotalRentalPrice: (state, getters) => {
            let rentalPrice = 0;

            lodash.forEach(state.vehicleRates, (rate, index) => {
                rentalPrice = rentalPrice + rate.totalPrice;
                if (index === 1) {
                    state.showDiscount = true;
                }
            })

            if (!lodash.isEmpty(getters.getActiveRentalOptions)) {
                rentalPrice = rentalPrice + getters.getOptionsTotalRentalPrice
            }

            if (getters.hasDiscount) {
              rentalPrice = rentalPrice - getters.getEffectiveDiscount;
              state.showDiscount = true;
            }

            return rentalPrice
        },

        getItemsForGA4: (state, getters) => {
            let items = [];

            items.push({
                'item_id': getters.getActiveVehicle.id,
                'item_name': getters.getActiveVehicle.title,
                'item_category': getters.getActiveVehicle.vehicle_group.label,
                'item_category2': getters.getDays,
                'location_id': getters.getActiveLocation.id,
                'price': getters.getTotalVehicleRates,
            });

            let optionPrice = 0;

            lodash.forEach(getters.getActiveRentalOptions, (option) => {
                optionPrice = 0;

                if (getters.getExternalRentalOptionPrices[option.id]) {
                    optionPrice = getters.getExternalRentalOptionPrices[option.id].total_price
                }

                if (option.isOneOff) {
                    optionPrice = option.price;
                }

                if(optionPrice <= 0) {
                    optionPrice = option.totalPrice;
                }

                items.push({
                    'item_id': option.tid,
                    'item_name': option.title,
                    'location_id': getters.getActiveLocation.id,
                    'item_category': "Extra opties",
                    'quantity': 1,
                    'price': optionPrice,
                });

            });

            return items;
        },

        getLongRentDiscount: (state, getters) => {
          let rentalPrice = 0;

          lodash.forEach(state.vehicleRates, (rate, index) => {
            if (index === 1) {
              rentalPrice = rentalPrice + rate.totalPrice;
            }
          })

          return Math.abs(rentalPrice);
        },

        getEffectiveDiscount: (state, getters) => {
            if (getters.hasDiscount && getters.getActiveDiscountType === 'fixed_price') {
                return getters.getActiveDiscount;
            }

            let rentalPrice = 0;
            let rentalPriceWithActiveDiscount = 0;

            lodash.forEach(state.vehicleRates, (rate, index) => {
                rentalPrice = rentalPrice + rate.totalPrice;
            })

            if (getters.hasDiscount && getters.getActiveDiscountType !== 'fixed_price') {
                rentalPriceWithActiveDiscount = rentalPrice - (rentalPrice / 100 * (100 - getters.getActiveDiscount));
            }

            return rentalPriceWithActiveDiscount;
        },

        getSubTotalRentalPrice: (state, getters) => {
            let rentalPrice = 0;

            lodash.forEach(state.vehicleRates, (rate, index) => {
                if(rate.totalPrice > 0){
                    rentalPrice = rentalPrice + rate.totalPrice;
                }
            })

            return rentalPrice
        },

        isAfterPickupTime: state => {
            let departureDate = moment(state.departureDate).format('YYYY-MM-DD');

            return (departureDate === moment().add(1, 'days').format('YYYY-MM-DD') &&
                moment().hour() >= state.activeLocation.endTimeReservation);
        },

        rentalOptionsFormattedForQuery: state => {
            let url = '';

            state.rentalOptions.forEach((rentalOption) => {
                url += `&optionIds[]=${rentalOption.id}`
            })

            return url;
        },

        getActivePickupPointFormattedAddress: state => {
            if (lodash.isEmpty(state.activePickupPoint)) {
                return '';
            }

            return `${state.activePickupPoint.streetName}, ${state.activePickupPoint.postalCode} ${state.activePickupPoint.place}`;
        },

        hasAlternativeVehicle: state => !lodash.isNil(state.activeVehicle.alternative_vehicle),
        hasBookableFrom: state => !lodash.isNil(state.activeVehicle.bookable_from),
        hasBookableTo: state => !lodash.isNil(state.activeVehicle.bookable_to),
        getAlternativeVehicle: state => state.activeVehicle.alternative_vehicle,
    },

    mutations: {
        SET_DEPARTURE_DATE(state, date) {
            state.departureDate = date;
        },

        SET_DEPARTURE_TIME(state, time) {
            state.departureTime = time;
        },

        SET_RETURN_DATE(state, date) {
            state.returnDate = date;
        },

        SET_RETURN_TIME(state, time) {
            state.returnTime = time;
        },

        SET_ACTIVE_LOCATION(state, location) {
            state.activeLocation = location;
        },

        SET_ACTIVE_LOCATION_OPENINGHOURS(state, locationOpeningHours) {
            state.activeLocationOpeningHours = locationOpeningHours;
        },

        SET_ACTIVE_PICKUP_POINT(state, pickupPoint) {
            state.activePickupPoint = pickupPoint;
        },

        SET_VEHICLE_RATES(state, vehicleRates) {
            state.vehicleRates = vehicleRates;
        },

        SET_DAYS(state, days) {
            state.days = days;
        },

        SET_DISCOUNT_AMOUNT(state, discount) {
            state.activeDiscount = discount;
        },

        SET_DISCOUNT_TYPE(state, type) {
            state.activeDiscountType = type;
        },

        SET_DISCOUNT_CODE(state, discountCode) {
            state.activeDiscountCode = discountCode;
        },

        SET_KILOMETERS(state, kilometers) {
            state.kilometers = kilometers
        },

        SET_ACTIVE_VEHICLE(state, vehicle) {
            state.activeVehicle = vehicle;
        },

        SET_CURRENT_STEP(state, value) {
            state.currentStep = value
        },

        SET_RENTAL_OPTIONS(state, rentalOptions) {
            state.rentalOptions = rentalOptions;
        },

        SET_UPGRADE(state, upgrade) {
            state.upgrade = upgrade;
        },

        SET_UPGRADES(state, upgrades) {
            state.upgrades = upgrades;
        },

        SET_DOWNGRADE(state, downgrade) {
            state.downgrade = downgrade;
        },

        SET_ACTIVE_RENTAL_OPTION(state, option) {
            state.activeRentalOptions.push(option.tid);
        },

        RESET_ACTIVE_RENTAL_OPTIONS(state) {
            state.activeRentalOptions = [12, 51];
        },

        RESET_ACTIVE_RENTAL_OPTIONS_BUSINESS(state) {
            state.activeRentalOptions = [94, 96];
        },

        REMOVE_ACTIVE_RENTAL_OPTION(state, option) {
            state.activeRentalOptions.splice(state.activeRentalOptions.indexOf(option.tid), 1);
        },

        SET_LOADING_VEHICLE_RATES(state, value) {
            state.loadingVehicleRates = value;
        },

        SET_SHOW_DISCOUNT(state, value) {
          state.showDiscount = value;
        },

        SET_FORM_TITLE(state, title) {
            state.form.title = title;
        },

        SET_FORM_FIRST_NAME(state, firstName) {
            state.form.first_name = firstName;
        },

        SET_FORM_LAST_NAME(state, lastName) {
            state.form.last_name = lastName;
        },

        SET_FORM_STREET(state, street) {
            state.form.street = street;
        },

        SET_FORM_HOUSE_NUMBER(state, houseNumber) {
            state.form.house_number = houseNumber;
        },

        SET_FORM_POSTAL_CODE(state, postalCode) {
            state.form.postal_code = postalCode;
        },

        SET_FORM_CITY(state, city) {
            state.form.city = city;
        },

        SET_FORM_COUNTRY(state, country) {
            state.form.country = country;
        },

        SET_FORM_EMAIL(state, email) {
            state.form.email = email;
        },

        SET_FORM_PHONE_NUMBER(state, phoneNumber) {
            state.form.phone_number = phoneNumber;
        },

        SET_FORM_NEWSLETTER(state, newsletter) {
            state.form.newsletter = newsletter;
        },

        SET_IS_LOGGED_IN(state, value) {
            state.isLoggedIn = value;
        },

        SET_FORM_CREATE_ACCOUNT(state, value) {
            state.form.create_account = value;
        },

        SET_FORM_PASSWORD(state, value) {
            state.form.password = value;
        },

        SET_FORM_PASSWORD_CONFIRM(state, value) {
            state.form.password_confirm = value;
        },

        SET_FORM_DATA(state, data) {
            lodash.forEach(data, (value, key) => {
                if (state.form.hasOwnProperty(key)) {
                    state.form[key] = value;
                }
            });
        },

        SET_LOADING_RENTAL_REQUEST(state, payload) {
            state.loadingRentalRequest = payload;
        },

        SET_DISABLED_RESERVATION_DATES(state, payload) {
            state.disabledReservationDates = payload;
        },

        SET_STORE_STATE_FROM_SESSION_STORAGE(state) {
            let sessionStorageStore = JSON.parse(sessionStorage.getItem('reservationStore'));

            lodash.forEach(sessionStorageStore, (value, key) => {
                state[key] = value;
            });
        },

        SET_STEP_TWO_DISABLED(state, payload) {
            state.stepTwoDisabled = payload;
        },

        SET_SHOW_LOCATION_DROPDOWN(state, payload) {
            state.showLocationDropdown = payload;
        },

        SET_POP_UP_SETTINGS(state, payload) {
            state.popUpSettings = payload;
        },

        SET_EXTERNAL_RENTAL_OPTION_PRICES(state, payload) {
            state.externalRentalOptionPrices = payload;
        },

        SET_EXTERNAL_PRICES_LOADING(state, payload) {
            state.externalPricesLoading = payload;
        },

        SET_BEGIN_CHECKOUT_STARTED(state, payload) {
          state.beginCheckoutStarted = payload;
        },

        SET_ACTIVE_VEHICLE_WRAPPER(state, payload) {
            state.activeVehicleWrapper = payload;
        }
    },

    actions: {
        setDepartureDate({commit}, date) {
            console.log('setDepartureDate', date);
            commit('SET_DEPARTURE_DATE', date);
        },

        setDepartureTime({commit}, time) {
            commit('SET_DEPARTURE_TIME', time);
        },

        setReturnDate({commit}, date) {
            commit('SET_RETURN_DATE', date);
        },

        setReturnTime({commit}, time) {
            commit('SET_RETURN_TIME', time);
        },

        setActiveLocation({commit}, location) {
            commit('SET_ACTIVE_LOCATION', location);
        },

        setActiveLocationOpeningHours({commit}, location) {
            commit('SET_ACTIVE_LOCATION_OPENINGHOURS', location);
        },

        setActivePickupPoint({commit}, pickupPoint) {
            commit('SET_ACTIVE_PICKUP_POINT', pickupPoint);
        },

        setKilometers({commit}, kilometers) {
            commit('SET_KILOMETERS', kilometers);
        },

        setDays({commit}, days) {
            commit('SET_DAYS', days);
        },

        setBeginCheckoutStarted({commit}, payload) {
          commit('SET_BEGIN_CHECKOUT_STARTED', payload);
        },

        setDiscountCode({commit}, discountCode) {
          commit('SET_DISCOUNT_CODE', discountCode);
        },

        setShowDiscount({commit}, value) {
          commit('SET_SHOW_DISCOUNT', value);
        },

        removeDiscountCode({commit}) {
          commit('SET_DISCOUNT_CODE', '');
          commit('SET_DISCOUNT_AMOUNT', null);
          commit('SET_DISCOUNT_TYPE', 'percentual');
        },

        async checkDiscountCodeValid({dispatch, commit, getters}) {
            const params = new URLSearchParams({
                vehicleId: getters.getActiveVehicle.id,
                discountCode: getters.getActiveDiscountCode,
                departure: getters.getStartDate,
                return: getters.getEndDate,
            });

            if (getters.getActiveLocation.id) {
                params.append('locationId', getters.getActiveLocation.id);
            }

            await axios.get(`/api/discount-rate?${params.toString()}`)
                .then(response => {
                    if (!isNumber(response.data.discountAmount)) {
                        dispatch('removeDiscountCode')

                        return
                    }

                    commit('SET_DISCOUNT_AMOUNT', response.data.discountAmount);
                });
        },

        async updateDiscountCode({dispatch, commit, getters}) {
            const params = new URLSearchParams({
                vehicleId: getters.getActiveVehicle.id,
                locationId: getters.getActiveLocation.id,
                discountCode: getters.getActiveDiscountCode,
                departure: getters.getStartDate,
                return: getters.getEndDate,
            });

            await axios.get(`/api/discount-rate?${params.toString()}`)
                .then(response => {
                    if (!isNumber(response.data.discountAmount)) {
                        dispatch('removeDiscountCode')

                        return
                    }

                    commit('SET_DISCOUNT_AMOUNT', response.data.discountAmount);
                    commit('SET_DISCOUNT_TYPE', response.data.discountType ?? 'percentual');
                });
        },

      handleGA4BeginCheckout({dispatch, commit, getters}) {
        if (getters.getBeginCheckoutStarted) {
          return;
        }
        dispatch('setBeginCheckoutStarted', true)
        window.dataLayer.push({
          'event': 'begin_checkout',
          'ecommerce': {
            'currency': 'EUR',
            'value': getters.getTotalRentalPrice,
            'items': [{
              'item_id': getters.getActiveVehicle.id,
              'item_name': getters.getActiveVehicle.title,
              'location_id': getters.getActiveLocation.id,
              'price': getters.getTotalVehicleRates,
              'item_category': getters.getActiveVehicle.vehicle_group.label,
              'item_category2': getters.getDays,
            }]
          }
        })
      },

      async updateVehicleRates({dispatch, commit, getters}, vehicleId) {
            commit('SET_LOADING_VEHICLE_RATES', true);

            await axios.get(`/api/vehicle-rates?vehicleId=${vehicleId}&locationId=${getters.getActiveLocation.id}&startDate=${getters.getStartDate}&endDate=${getters.getEndDate}&freeKilometers=${getters.getActiveVehicle.free_kilometers ?? 100}`)
                .then(response => {
                    if (response.data.redirect_to) {
                        window.location = response.data.redirect_to;
                    }

                    commit('SET_VEHICLE_RATES', response.data.rates);
                    commit('SET_DAYS', response.data.days);
                    commit('SET_KILOMETERS', response.data.kilometers);
                })
                .finally(() => {
                  commit('SET_LOADING_VEHICLE_RATES', false);
                  dispatch('handleGA4BeginCheckout');
                })
        },

        async updateLocationOpeningHours({dispatch, commit, getters}) {
            await axios.get(`/api/location-openinghours?locationId=${getters.getActiveLocation.id}&startDate=${getters.getStartDate}`)
                .then(response => {
                    commit('SET_ACTIVE_LOCATION_OPENINGHOURS', response.data);
                })
                .catch(error => {
                    commit('SET_ACTIVE_LOCATION_OPENINGHOURS', {});
                })
        },

        async setActiveVehicle({commit, getters}, vehicleId) {
          await axios.get(`/api/vehicle-details?vehicleId=${vehicleId}`)
            .then(response => {
                commit('SET_ACTIVE_VEHICLE', response.data);
            })
            .catch(error => {
              setInterval(function(){
                window.location = getters.getActiveLocation.url;
              }, 300);

              commit('SET_ACTIVE_VEHICLE', {});
            });
        },

        setActiveVehicleWrapper({commit, getters}, payload) {
            let url = `/api/vehicle-wrapper-details?vehicleWrapperId=${payload.vehicleWrapperId}`;

            if (payload.locationId) {
                url += `&locationId=${payload.locationId}`;
            }

            axios.get(url)
                .then(response => {
                    commit('SET_ACTIVE_VEHICLE_WRAPPER', response.data);
                })
                .catch(error => {
                    comment('SET_ACTIVE_VEHICLE_WRAPPER', {});
                })
        },

        setCurrentStep({commit}, value) {
            commit('SET_CURRENT_STEP', value);
        },

        setRentalOptions({dispatch, commit, getters}, payload = { vehicleId: null, isUpgrade: false }) {
            let checkedVehicleId = payload.vehicleId ?? null;

            if (getters.getActiveVehicle.id) {
                checkedVehicleId = getters.getActiveVehicle.id;
            }

            axios.get(
                `/api/reservation/rental-options?vehicleId=`+
                `${checkedVehicleId}&locationId=${getters.getActiveLocation.id}&days=${getters.getDays}`+
                `&departure=${getters.getStartDate}&return=${getters.getEndDate}`
            )
                .then(response => {

                  if (response.data.redirect_to) {
                    window.location = response.data.redirect_to;
                  }

                  commit('SET_RENTAL_OPTIONS', response.data.options)

                    if (payload?.isUpgrade !== true) {
                        commit('SET_UPGRADE', response.data.vehicles.upgrade);
                        commit('SET_UPGRADES', response.data.vehicles.upgrades);
                        commit('SET_DOWNGRADE', response.data.vehicles.downgrade);
                    }
                })
                .catch(error => {
                    commit('SET_RENTAL_OPTIONS', {})
                    commit('SET_UPGRADE', null);
                    commit('SET_UPGRADES', []);
                    commit('SET_DOWNGRADE', null);
                })
                .finally(() => {
                    dispatch('setExternalRentalOptionPrices')
                });
        },

        setExternalRentalOptionPrices({commit, getters}) {
            if (lodash.isEmpty(getters.getRentalOptions)) {
                return;
            }

            commit('SET_EXTERNAL_PRICES_LOADING', true);
            let url = `/api/external-option-rates-prices?optionClass=${getters.getActiveVehicle.external_id}&locationId=${getters.getActiveLocation.externalId}`;
            url += `&startDate=${moment(getters.getDepartureDate).format('YYYY-MM-DD')} ${getters.getDepartureTime}&endDate=${moment(getters.getReturnDate).format('YYYY-MM-DD')} ${getters.getReturnTime}`
            url += getters.rentalOptionsFormattedForQuery;

            axios.get(url)
                .then(response => {
                    commit('SET_EXTERNAL_RENTAL_OPTION_PRICES', response.data)
                })
                .catch((error) => {
                    commit('SET_EXTERNAL_RENTAL_OPTION_PRICES', {})
                })
                .finally(() => {
                    commit('SET_EXTERNAL_PRICES_LOADING', false);
                })
        },

        setActiveRentalOption({commit, getters}, option) {
            if (lodash.includes(getters.getActiveRentalOptionIds, option.tid)) {
                return;
            }

            commit('SET_ACTIVE_RENTAL_OPTION', option);

        },

        resetActiveRentalOptions({commit}, isBusiness) {
            if(isBusiness) {
                commit('RESET_ACTIVE_RENTAL_OPTIONS_BUSINESS');
                return;
            }

            commit('RESET_ACTIVE_RENTAL_OPTIONS');
        },

        removeActiveRentalOption({commit}, option) {
            commit('REMOVE_ACTIVE_RENTAL_OPTION', option);
        },

        async changeVehicle({dispatch, commit}, payload) {
            dispatch('resetActiveRentalOptions', payload.isBusiness)
            dispatch('removeDiscountCode')

            await dispatch('setActiveVehicle', payload.vehicleId).finally(() => {
                dispatch('setRentalOptions', payload).finally(() => {
                    dispatch('updateVehicleRates', payload.vehicleId);
                });
            });
        },

        setFormValue({commit}, payload) {
            commit(`SET_FORM_${payload.key}`, payload.value);
        },

        setLoadingRentalRequest({commit}, payload) {
            commit('SET_LOADING_RENTAL_REQUEST', payload);
        },

        setDisabledReservationDates({commit}, payload) {
            commit('SET_DISABLED_RESERVATION_DATES', payload);
        },

        async setStoreInSessionStorage({commit, state}) {
            await sessionStorage.setItem('reservationStore', JSON.stringify(state));
        },

        setStoreStateFromSessionStorage({commit}) {
            commit('SET_STORE_STATE_FROM_SESSION_STORAGE');
        },

        setStepTwoDisabled({commit}, payload) {
            commit('SET_STEP_TWO_DISABLED', payload);
        },

        setShowLocationDropdown({commit}, payload) {
            commit('SET_SHOW_LOCATION_DROPDOWN', payload);
        },

        setPopUpSettings({commit}, payload) {
            commit('SET_POP_UP_SETTINGS', payload)
        }
    },
});
